import { atom } from 'recoil';
export var boundaryState = atom({
    key: 'boundary',
    default: {
        width: 0,
        height: 0,
    },
});
